module.exports = __webpack_public_path__ + "static/media/d10kz.be586b1f.pdf";